<template>
    <v-container fluid fill-height>
        <v-layout flex align-center justify-center>
            <div class="wrapper-reset-password">
                <h1 class="headline">Set new Password</h1>
                <v-layout v-show="errorShow">
                    <span class="error--text test-xs-center">{{message}}</span>
                </v-layout>
                <v-layout v-show="successShow">
                    <span class="success--text test-xs-center">{{message}}</span>
                </v-layout>
                <v-form>
                    <v-text-field
                        id="password"
                        name="password"
                        label="New password"
                        v-model.trim="password_reset.password"
                        required
                        :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="e1 = !e1"
                        :type="e1 ? 'password' : 'text'"
                        placeholder="Please Enter"
                        :error-messages="errors($v.password_reset.password)"
                        @blur="$v.password_reset.password.$touch()"
                        @focus="resetServerValidation"
                        @keydown.enter="reset_password"
                    >
                    </v-text-field>
                    <v-text-field
                        id="password_confirm"
                        name="password_confirm"
                        label="New password confirm"
                        class="mb-3"
                        v-model.trim="password_reset.password_confirmation"
                        required
                        :append-icon="e2 ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="e2 = !e2"
                        :type="e2 ? 'password' : 'text'"
                        placeholder="Please Enter"
                        :error-messages="errors($v.password_reset.password_confirmation)"
                        @blur="$v.password_reset.password_confirmation.$touch()"
                        @focus="resetServerValidation"
                        @keydown.enter="reset_password"
                    >
                    </v-text-field>
                    <v-alert class="pa-2 mt-3" :value="$v.password_reset.$error" outlined color="error" icon="mdi-alert" transition="scale-transition">
                        <span class="caption">Please fill out form correctly</span>
                    </v-alert>
                    <v-alert class="pa-2 mt-3" :value="!serverValidation" outlined color="error" icon="mdi-alert" transition="scale-transition">
                        <span class="caption">{{ serverValidationMessage }}</span>
                    </v-alert>
                    <v-btn
                        id="btnResetPassword"
                        block
                        color="primary"
                        :loading="loading"
                        :disabled="loading"
                        @click="reset_password"
                    >
                        Save new password
                    </v-btn>
                    <div v-show="showLoginPage" class="text-center mt-3">
                        <router-link to="/">Back to Login page</router-link>
                    </div>
                </v-form>
            </div>

            <!-- Password Reseted -->
            <v-dialog v-model="passwordResetDialog" max-width="500px" persistent>
                <v-card class="pa-3">
                    <v-card-title>
                        <h2 class="title">Password Reset</h2>
                    </v-card-title>
                    <div class="px-7 py-4">
                        <v-alert class="pa-2 mb-5 mt-2" :value="true" outlined color="info" icon="mdi-information" transition="scale-transition">
                            <span class="default-text body-2">Your Password has been successfully reset.</span>
                        </v-alert>
                    </div>
                    <v-card-actions class="px-3">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="$router.push('/login')">Go to Login Page</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>


<script>
    import ApiService from "@/common/api.service"
    import { validationMixin } from 'vuelidate'
    import { required, sameAs, minLength } from 'vuelidate/lib/validators'
    import { valMessages, getValMessage } from '@/common/error-messages'

    const validations = {
        password_reset: {
            password: { required, txtMinLen: minLength(8) },
            password_confirmation: { required, txtMinLen: minLength(8), sameAsPassword: sameAs('password') }
        }
    }
    export default {
        name: 'ChangePasswordToken',
        mixins: [validationMixin],
        validations,
        data: () => ({
            loading: false,
            message: '',
            errorShow: false,
            successShow: false,
            password_reset: {
                token: '',
                password: '',
                password_confirmation: '',
            },
            e1: true,
            e2: true,
            showLoginPage: false,
            passwordResetDialog: false,
            serverValidation: true,
            serverValidationMessage: 'Oops something went wrong...',
        }),
        beforeMount(){
            this.password_reset.token = this.$route.params.token;
        },
        methods: {
            reset_password() {
                this.resetServerValidation()
                this.$v.password_reset.$touch()
                if(!this.$v.password_reset.$invalid) {
                    this.message = '';
                    this.loading = true
                    ApiService.put('/password_save', this.password_reset)
                        .then(response => {
                            this.$v.$reset()
                            if (!!response.data.success) {
                                this.loading = false
                                this.password_reset = {};
                                this.message = "You can login now with new password!";
                                this.errorShow = false;
                                this.successShow = true;
                                this.showLoginPage = true;
                                this.passwordResetDialog = true
                            } else {
                                this.loading = false
                                this.password_reset.password = '';
                                this.password_reset.password_confirmation = '';
                                this.message = "Some data is not valid!";
                                this.errorShow = true;
                                this.successShow = false;
                                this.showLoginPage = false;
                            }
                        })
                        .catch(({ response }) => {
                            this.loading = false
                            this.serverValidation = false
                            if(response.data.errors){
                                if(response.data.errors.password) {
                                    this.serverValidationMessage = response.data.errors.password[0]
                                } else {
                                    this.serverValidationMessage = response.data.errors[0]
                                }
                            }
                        });
                }
            },
            resetServerValidation() {
                this.serverValidation = true
                this.serverValidationMessage = 'Oops something went wrong...'
            },
            errors: getValMessage(valMessages)(validations)
        }
    }
</script>

<style lang="css">
    .wrapper-reset-password h1 {
        text-align: center;
        padding-bottom: 20px;
    }

    .wrapper-reset-password {
        width: 100%;
        max-width: 300px;
    }

    .btn__content {
        padding-top: 2px;
        height: fit-content;
    }
</style>
